import { Row } from "antd";
import { memo } from "react";
import { Link } from "react-router-dom";
import ROUTES from "../../../../../../configs/routesConfig";

type AddressInfoProps = {
  propertyAddress: string | null;
  contractNumber: number;
  isConvLabel?: boolean;
};

const AddressInfo = memo(
  ({
    propertyAddress,
    contractNumber,
    isConvLabel = true,
  }: AddressInfoProps) => {
    return (
      <Row className={`address-info align-center ${isConvLabel ? "mb-2" : ""}`}>
        <span className="text-md title address-title elipsis">
          {propertyAddress || "My Escrow"}
        </span>
        <div className="elipse mx-1" />
        {isConvLabel ? (
          <span className="text-md title">#{contractNumber}</span>
        ) : (
          <Link to={`${ROUTES.ACCOUNTS}/${contractNumber}`}>
            <span className="text-md title underline">#{contractNumber}</span>
          </Link>
        )}
      </Row>
    );
  },
);

export default AddressInfo;
